// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#easycommerce-filter img {
    border: 1px solid#DBDBDB;
    padding: 9px;
    border-radius: 8px;
    box-shadow: 0px 4px 12px 0px #0000001a;
    backdrop-filter: blur(5px);
    background: #ffffff0f;
    left: 20px;
}
.easycommerce-thumbnail-img {
    width: 100%;
    max-height: 320px;
    -o-object-fit: cover;
       object-fit: cover;
}
.easycommerce-add-to-cart-shop:hover {
    color: #fff !important;
}

.easycommerce-drawer-container {
    width: 300px;
}
.easycommerce-shop-container {
    width: calc(100% - 300px);
}
.easycommerce-price-range-input-field,
.easycommerce-price-range-input-field:focus {
    border: 1px solid var(--color-ec-border) !important;
}
.easycommerce-price-range-input-field::-webkit-outer-spin-button,
.easycommerce-price-range-input-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
.easycommerce-price-range-input-field[type="number"] {
    -moz-appearance: textfield;
}
.easycommerce-drawer-wrap-st {
    align-self: flex-end !important;
}

/* Shop Trendy grid/list icon active inactive button color css */

.easycommerce-shop-st-grid-btn svg rect:first-child,
.easycommerce-shop-st-list-btn svg rect:first-child {
    fill: #FFFFFF;
    stroke: #EBEBEB;
}

.easycommerce-shop-st-grid-btn svg path,
.easycommerce-shop-st-list-btn svg path {
    fill: #272435;
}

/* Active state */
.easycommerce-shop-st-grid-btn.active svg rect:first-child,
.easycommerce-shop-st-list-btn.active svg rect:first-child {
    fill: #272435;
    stroke: #272435;
}

.easycommerce-shop-st-grid-btn.active svg path,
.easycommerce-shop-st-list-btn.active svg path {
    fill: #FFFFFF;
}


@media (min-width: 1024px) {
    .easycommerce-drawer-close {
        visibility: hidden !important;
    }
}

@media (max-width: 991px) {
    /* .easycommerce-shop-container {
        width: 100%;
    } */
    .easycommerce-drawer-wrap-st {
        margin-top: 34px;
    }
}
@media (max-width: 768px) {
    /* .easycommerce-shop-container {
        width: 100%;
    } */
    .easycommerce-drawer-wrap-st {
        margin-top: 47px;
    }
}
@media (max-width: 576px) {
    .easycommerce-filters-st {
        width: 80% !important;
    }
}
@media (max-width: 425px) {
    .easycommerce-shop-container-st.hidden {
        display: none !important;
    }
    .easycommerce-shop-container-st:not(.hidden) {
        display: grid !important;
        grid-template-columns: 1fr !important;
    }

    .easycommerce-product-price-wrap-st {
        display: flex !important;
        flex-direction: row !important;
        gap: 0.25rem !important;
    }
}

`, "",{"version":3,"sources":["webpack://./blocks/shops-page/shop-trendy/components/assets/style.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAiB;OAAjB,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA,YAAY;AACZ;IACI,0BAA0B;AAC9B;AACA;IACI,+BAA+B;AACnC;;AAEA,gEAAgE;;AAEhE;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;;AAGA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;;OAEG;IACH;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;;OAEG;IACH;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,qCAAqC;IACzC;;IAEA;QACI,wBAAwB;QACxB,8BAA8B;QAC9B,uBAAuB;IAC3B;AACJ","sourcesContent":["#easycommerce-filter img {\n    border: 1px solid#DBDBDB;\n    padding: 9px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 12px 0px #0000001a;\n    backdrop-filter: blur(5px);\n    background: #ffffff0f;\n    left: 20px;\n}\n.easycommerce-thumbnail-img {\n    width: 100%;\n    max-height: 320px;\n    object-fit: cover;\n}\n.easycommerce-add-to-cart-shop:hover {\n    color: #fff !important;\n}\n\n.easycommerce-drawer-container {\n    width: 300px;\n}\n.easycommerce-shop-container {\n    width: calc(100% - 300px);\n}\n.easycommerce-price-range-input-field,\n.easycommerce-price-range-input-field:focus {\n    border: 1px solid var(--color-ec-border) !important;\n}\n.easycommerce-price-range-input-field::-webkit-outer-spin-button,\n.easycommerce-price-range-input-field::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n/* Firefox */\n.easycommerce-price-range-input-field[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n.easycommerce-drawer-wrap-st {\n    align-self: flex-end !important;\n}\n\n/* Shop Trendy grid/list icon active inactive button color css */\n\n.easycommerce-shop-st-grid-btn svg rect:first-child,\n.easycommerce-shop-st-list-btn svg rect:first-child {\n    fill: #FFFFFF;\n    stroke: #EBEBEB;\n}\n\n.easycommerce-shop-st-grid-btn svg path,\n.easycommerce-shop-st-list-btn svg path {\n    fill: #272435;\n}\n\n/* Active state */\n.easycommerce-shop-st-grid-btn.active svg rect:first-child,\n.easycommerce-shop-st-list-btn.active svg rect:first-child {\n    fill: #272435;\n    stroke: #272435;\n}\n\n.easycommerce-shop-st-grid-btn.active svg path,\n.easycommerce-shop-st-list-btn.active svg path {\n    fill: #FFFFFF;\n}\n\n\n@media (min-width: 1024px) {\n    .easycommerce-drawer-close {\n        visibility: hidden !important;\n    }\n}\n\n@media (max-width: 991px) {\n    /* .easycommerce-shop-container {\n        width: 100%;\n    } */\n    .easycommerce-drawer-wrap-st {\n        margin-top: 34px;\n    }\n}\n@media (max-width: 768px) {\n    /* .easycommerce-shop-container {\n        width: 100%;\n    } */\n    .easycommerce-drawer-wrap-st {\n        margin-top: 47px;\n    }\n}\n@media (max-width: 576px) {\n    .easycommerce-filters-st {\n        width: 80% !important;\n    }\n}\n@media (max-width: 425px) {\n    .easycommerce-shop-container-st.hidden {\n        display: none !important;\n    }\n    .easycommerce-shop-container-st:not(.hidden) {\n        display: grid !important;\n        grid-template-columns: 1fr !important;\n    }\n\n    .easycommerce-product-price-wrap-st {\n        display: flex !important;\n        flex-direction: row !important;\n        gap: 0.25rem !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
